import { map } from "lodash";
import { SCAttributes } from "../../common/generic/generic-sc-attributes";
import { SCKpis } from "../../common/generic/generic-sc-domain";
import { IGenericAggregateResponse } from "../../common/generic/generic-types";
import { AgFormat } from "../../common/utils/agGridFormat";
import {
  AirRetentionRateKpis,
  IBookValueAdjustBySales,
} from "../../common/utils/AirPnlRetentionRate/AirPnlTypes";

export const mapToBookValueAdjustBySales = (
  response: IGenericAggregateResponse
): IBookValueAdjustBySales[] =>
  response
    ? map(
        response.aggregates,
        ({ indicatorKpiValues, dimensionAttributeValues }) =>
          ({
            FpvTradingNegoEntityRegion:
              dimensionAttributeValues[
                SCAttributes.SC_FPV_TRADE_NEGO_ENTITY_REGION
              ],
            BvAdjust: indicatorKpiValues[AirRetentionRateKpis.BV_ADJUST],
            RetentionRateEquiv:
              indicatorKpiValues[AirRetentionRateKpis.RETENTION_RATE_EQUIV],
            SalesName: dimensionAttributeValues[SCAttributes.SC_SALESBEN_SALES],
            ScYtd: indicatorKpiValues[SCKpis.SC_YTD],
          } as IBookValueAdjustBySales)
      )
    : [];

const cellStyle = "text-right";

export const GetHeaders = () => [
  {
    field: "FpvTradingNegoEntityRegion",
    headerName: "FPV trading - nego entity region",
    width: 50,
  },
  {
    field: "SalesName",
    headerName: "Sales",
    width: 50,
  },
  {
    cellClass: cellStyle,
    comparator: AgFormat.AgNumberComparator,
    field: "ScYtd",
    filter: "number",
    filterParams: { comparator: AgFormat.AgNumberComparator },
    headerName: "SC YTD (K€)",
    valueGetter: AgFormat.AgGridFormatMoney,
    width: 30,
  },
  {
    cellClass: cellStyle,
    comparator: AgFormat.AgNumberComparator,
    field: "BvAdjust",
    filter: "number",
    filterParams: { comparator: AgFormat.AgNumberComparator },
    headerName: "BV adjust (K€)",
    valueGetter: AgFormat.AgGridFormatMoney,
    width: 30,
  },
  {
    cellClass: cellStyle,
    comparator: AgFormat.AgNumberComparator,
    field: "RetentionRateEquiv",
    filter: "number",
    filterParams: { comparator: AgFormat.AgNumberComparator },
    headerName: "Retention rate adjust",
    valueGetter: AgFormat.AgGridFormatPercentageWithSeparator,
    width: 30,
  },
];
